import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';

const prefix = '[StopManyProductionInstances] ';

export const stopManyProductionInstances = createAction(
  `${prefix} Stop Many Production Instances`,
  props<{ ids: UUID[] }>()
);

export const stopManyProductionInstancesSuccess = createAction(
  `${prefix} Stop Many Production Instances Success`,
  props<{ ids: UUID[] }>()
);

export const stopManyProductionInstancesFailure = createAction(
  `${prefix} Stop Many Production Instances Failure`,
  props<{ error: any }>()
);

export const clearStopManyProductionInstancesState = createAction(
  `${prefix} Clear Stop Many Production Instances State`
);
